import { CONSULTATIONS_PAGE_SLUG } from 'constants/common'

interface IsConsultationPageProps {
  slug: string
  isConsultationsIndexPage?: boolean
}

export const isConsultationPage = ({
  slug,
  isConsultationsIndexPage,
}: IsConsultationPageProps): boolean =>
  slug === CONSULTATIONS_PAGE_SLUG && !isConsultationsIndexPage
